module.exports = __webpack_public_path__ + "img/img-29.1fe586e5.png";